import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
//import * as serviceWorker from "./serviceWorker";
import AppRoutes from "./AppRoutes";
import "./css/layout.css";
import "./css/style.css";
//import "./css/fabric-erp-professional-overrides.css";
//import "./css/fabric-erp-professional-overrides-v2.css";

//import "./css/main.css";
import ErrorBoundary from "./gui_components/ErrorBoundary";

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById("root")
// );

//ReactDOM.render(<AppRoutes />, document.getElementById("root"));

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <AppRoutes />
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

//serviceWorker.unregister();
